// For development

// export const ApiUrl = "http://127.0.0.1:8000/api";

// For Production

export const ApiUrl = "https://cms.friaryparish.com/api";